// Single source of truth for everything the recognizer may hear.
// No voice commands: session actions (repeat, definition, clear, skip, done,
// stop) are on-screen buttons.
import HOMOPHONES from './letter-homophones.json';

export const LETTERS = {
  a: 'a', ay: 'a',
  b: 'b', be: 'b', bee: 'b',
  c: 'c', cee: 'c', sea: 'c', see: 'c',
  d: 'd', dee: 'd',
  e: 'e', ee: 'e',
  f: 'f', ef: 'f', eff: 'f',
  g: 'g', gee: 'g',
  h: 'h', aitch: 'h', haitch: 'h',
  i: 'i', eye: 'i',
  j: 'j', jay: 'j',
  k: 'k', kay: 'k',
  l: 'l', el: 'l', ell: 'l',
  m: 'm', em: 'm',
  n: 'n', en: 'n',
  o: 'o', oh: 'o',
  p: 'p', pea: 'p', pee: 'p',
  q: 'q', cue: 'q', queue: 'q',
  r: 'r', are: 'r', ar: 'r',
  s: 's', ess: 's',
  t: 't', tea: 't', tee: 't',
  u: 'u', you: 'u',
  v: 'v', vee: 'v',
  w: 'w', 'double you': 'w',
  x: 'x', ex: 'x', 'x ray': 'x',
  y: 'y', why: 'y',
  z: 'z', zee: 'z', zed: 'z'
};

// Words an open-vocabulary recognizer (the browser fallback) returns for spoken
// letter sequences: exact homophones derived from CMUdict by eval/gen_homophones.py
// (excess=xs, cagey=kg, empty=mt …) plus hand-listed near-misses. Only honoured
// when the result matches the target word, so they can never turn a wrong answer
// into a right one.
export const RESCUES = {
  ...HOMOPHONES,
  end: 'n', and: 'n', an: 'n', in: 'n', inn: 'n',
  am: 'm', um: 'm', owe: 'o', ohh: 'o', own: 'on', ohkay: 'ok',
  eyes: 'is', ease: 'es', tease: 'ts', seen: 'cn', seat: 'ct', sees: 'cs', use: 'us', yes: 'ys',
  art: 'rt', our: 'r', oar: 'r', al: 'l', ale: 'l', ail: 'l', us: 's', tv: 'tv', tp: 'tp',
  bees: 'bs', de: 'd', ge: 'g', gp: 'gp', zeta: 'z'
};

// Phrases Vosk may emit. Only bare letters plus forms with a distinct
// pronunciation: synonyms like "bee"/"pee"/"see" share the letter's phonemes,
// so they add ambiguity (a fast "p e" can decode as "pee") without adding
// coverage — measured on eval corpora, dropping them is neutral-to-better.
// "zed" is kept for British spellers; "double you"/"x ray" are not needed —
// the model already pronounces "w" as double-you, and spellers do not say "x ray".
const VOSK_EXTRA_FORMS = ['zed'];
export const VOSK_GRAMMAR = [
  ...Object.keys(LETTERS).filter(key => key.length === 1 || VOSK_EXTRA_FORMS.includes(key)),
  '[unk]'
];
